import { SyntheticEvent } from "react";
import { FloorLayers } from "@iko-design-center/shared";
import { useTranslation } from "react-i18next";
import {
  allSelectedDownloadState,
  getLayerOptions,
} from "../../../store/floor/download";
import { useFloor } from "../../../store/floor/hooks";
import { useModal } from "../../../store/modal/hooks";

type ToggleAllOptions = "DOP" | "technicalFiche";

export function useDownload() {
  const { setDownloadState, downloadState } = useFloor();
  const { closeModal, displayFloorDownloadMailModal } = useModal();
  const { t } = useTranslation();

  function selectAll() {
    setDownloadState(allSelectedDownloadState);
  }

  function handleCardClick(e: SyntheticEvent) {
    e.stopPropagation();
  }

  const technicalFicheOptions = getLayerOptions({
    t,
    state: downloadState.technicalFiche,
  });
  const DOPOptions = getLayerOptions({
    t,
    state: downloadState.DOP,
  });

  function toggleAll(kind: ToggleAllOptions) {
    switch (kind) {
      case "technicalFiche":
        const technicalFicheChecked =
          downloadState.technicalFiche.floorInsulation &&
          downloadState.technicalFiche.floorScreed;

        setDownloadState({
          ...downloadState,
          technicalFiche: {
            floorInsulation: !technicalFicheChecked,
            floorScreed: !technicalFicheChecked,
          },
        });
        break;
      case "DOP":
        const DOPChecked =
          downloadState.DOP.floorInsulation && downloadState.DOP.floorScreed;

        setDownloadState({
          ...downloadState,
          DOP: {
            floorInsulation: !DOPChecked,
            floorScreed: !DOPChecked,
          },
        });
        break;
    }
  }

  function toggleLayersOption(kind: ToggleAllOptions, value: FloorLayers) {
    switch (kind) {
      case "technicalFiche":
        setDownloadState({
          ...downloadState,
          technicalFiche: {
            ...downloadState.technicalFiche,
            [value]: !downloadState.technicalFiche[value],
          },
        });
        break;
      case "DOP":
        setDownloadState({
          ...downloadState,
          DOP: {
            ...downloadState.DOP,
            [value]: !downloadState.DOP[value],
          },
        });
        break;
    }
  }

  function toggle(
    kind:
      | "specifications"
      | "BIMFile"
      | "screenshots"
      | "thermalCalculation"
      | "processingGuideline"
  ) {
    setDownloadState({
      ...downloadState,
      [kind]: !downloadState[kind],
    });
  }

  function handleDownload() {
    displayFloorDownloadMailModal();
  }

  return {
    t,
    handleCardClick,
    closeModal,
    selectAll,
    technicalFicheOptions,
    toggleAll,
    toggleLayersOption,
    DOPOptions,
    downloadState,
    toggle,
    handleDownload,
  };
}
